import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { FuseLoadingService } from '@fuse/services/loading/loading.service';
import { Observable, finalize, take } from 'rxjs';

export const fuseLoadingInterceptor = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
    const fuseLoadingService = inject(FuseLoadingService);
    let handleRequestsAutomatically = false;

    fuseLoadingService.auto$.pipe(take(1)).subscribe((value) => {
        handleRequestsAutomatically = value;
    });

    // If the Auto mode is turned off, do nothing
    if (!handleRequestsAutomatically) {
        return next(req);
    }

    // Skip loading bar for Gemini endpoints to prevent NG0100 errors
    // Gemini requests are handled asynchronously and don't need the global loading bar
    if (req.url.includes('/gemini/')) {
        return next(req);
    }

    // Skip loading bar for background operations that happen frequently
    // These shouldn't show the global loading indicator as they're silent polling/downloads
    const backgroundEndpoints = [
        '/nylasEmailAttachmentDownload',  // Email attachment downloads
        '/v2/orders/count',               // Order count polling
        '/conversations',                  // Chat conversations polling
    ];
    
    if (backgroundEndpoints.some(endpoint => req.url.includes(endpoint))) {
        return next(req);
    }

    // Set the loading status to true
    fuseLoadingService._setLoadingStatus(true, req.url);

    return next(req).pipe(
        finalize(() => {
            // Set the status to false if there are any errors or the request is completed
            fuseLoadingService._setLoadingStatus(false, req.url);
        })
    );
};
